import { SxProps, Theme } from "@mui/material";

export const NoteEditorStyles: Record<string, SxProps<Theme>> = {
  container: {
    border: "1px solid #999",
    borderRadius: "4px",
    margin: "16px",
    backgroundColor: "#ffffff",
  },
  titleBar: {
    backgroundColor: "#64b5f6",
    padding: "8px",
    textAlign: "center",
  },
  titleText: {
    color: "white",
    fontWeight: "bold",
  },
  noteEntry: {
    fontSize: "0.9rem",
    whiteSpace: "pre-wrap",
  },
  inputArea: {
    px: 2,
    py: 2,
  },
  buttonRow: {
    display: "flex",
    justifyContent: "center",
    gap: 16,
    px: 4,
    pb: 3,
  },
  orangeButton: {
    backgroundColor: "#e0a56d",
    color: "white",
    fontWeight: "bold",
    boxShadow: 3,
    "&:hover": {
      backgroundColor: "#d79652",
    },
  },
};
